import moment from 'moment-timezone';
import { DateFormats } from 'UI/constants/defaults';
import { toLocalTime } from 'UI/utils';

const EMPTY_VALUE = '---';

export const formatInterviewDate = ({ interviewDate, interviewTimeZone } = {}) => {
  const interviewTime =
    interviewDate && interviewTimeZone
      ? moment.utc(interviewDate).tz(interviewTimeZone)
      : toLocalTime(interviewDate);
  const formattedDate = interviewTime && interviewTime.format(DateFormats.SimpleDateTime);

  if (!formattedDate) return EMPTY_VALUE;

  return interviewTimeZone ? `${formattedDate} (${interviewTime.format('z')})` : formattedDate;
};
